var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"cms-filter-select",attrs:{"outlined":_vm.outlined,"flat":_vm.flat,"solo":_vm.solo,"menu-props":{ outlined: true },"dense":_vm.dense,"item-color":_vm.itemColor || _vm.color,"color":_vm.color,"items":_vm.times,"item-text":function (ref) {
	var text = ref.text;

	return _vm.$t(("time." + text));
},"return-object":"","hide-details":"","prepend-inner-icon":"mdi-sort-clock-ascending-outline"},on:{"change":function (ref) {
	var text = ref.text;

	return _vm.updateQuery({ time: text });
}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})}
var staticRenderFns = []

export { render, staticRenderFns }